<template>
  <div class="param" v-loading="isLoading" element-loading-spinner="el-icon-loading" @click.stop="closeSetting">
    <div class="param-title">
      <span>{{$t("device.dataview")}}</span>
      <!-- <span class="text">{{type==='protocol'?$t('device.parameter'):''}}</span> -->
      <el-popover v-model="settingVisible" class="param-set" popper-class="param-choose" @click.stop>
        <div class="title">{{$t('device.chosenParam')}}</div>
        <div v-if="chosenFields.length>1" class="tag-container">
          <el-tag class="tag-chosen" :class="{clickable: chosenFields.length>1}" v-for="field in chosenFields" @click="setField(field,false)" :key="field.optional">
            {{field.name}}
            <i class="el-icon-close" @click="setField(field,false)"></i>
          </el-tag>
        </div>
         <div v-else class="tag-container">
          <el-tag class="tag-chosen" :class="{clickable: chosenFields.length>1}" v-for="field in chosenFields" :key="field.optional">
            {{field.name}}
            <i class="el-icon-close" @click="setField(field,false)"></i>
          </el-tag>
        </div>
        <div class="title">{{$t('device.optionalParam')}}</div>
        <div v-if="chosenFields.length<5" class="tag-container">
          <el-tag class="tag-optional" :class="{clickable: chosenFields.length<5}" v-for="field in optionalFields" @click="setField(field,true)" :key="field.optional">
            {{field.name}}
            <i class="el-icon-check" @click="setField(field,true)"></i>
          </el-tag>
        </div>
        <div v-else class="tag-container">
          <el-tag class="tag-optional" :class="{clickable: chosenFields.length<5}" v-for="field in optionalFields" :key="field.optional">
            {{field.name}}
            <i class="el-icon-check" @click="setField(field,true)"></i>
          </el-tag>
        </div>
        <div class="footer">
          <button class="button-hollow" @click="resetField">{{$t('device.reset')}}</button>
          <button class="button-solid" @click="closeSetting">{{$t('device.confirm')}}</button>
        </div>
        <i slot="reference" class="iconfont icon-set" @click.stop></i>
      </el-popover>
    </div>
    <div class="param-list" :class="{'protocol':type==='protocol','device':type==='device'}">
      <!-- 因无数据时为空造成报错 Duplicate keys detected故引用index -->
      <div 
        v-for="(field, index) in fieldDataList" 
        :key="field.par ? field.par : index"
        class="param-data" 
        :class="{'protocol':type==='protocol','device':type==='device'}"
      >
        <div class="num">{{field.val | formatNum(2)}}{{field.unit}}</div>
        <div class="name">{{field.name}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    deviceInfo: {
      type: Object
    }
  },
  watch: {
    deviceInfo: {
      handler() {
        this.queryData()
      },
      deep: true
    }
  },
  data() {
    return {
      timerEnergyFiled: "",
      fieldList: [], // 可选参数列表
      fieldDataList: [], // 显示的参数数据
      settingVisible: false, // 参数选择框是否可见
      isLoading: false, // 正在加载数据
    }
  },
  computed: {
    // 协议参数或设备参数
    type() {
      return this.deviceInfo.sn ? 'device' : 'protocol'
    },
    chosenFields () {
      return this.fieldList.filter(item => !!item.visable)
    },
    optionalFields () {
      return this.fieldList.filter(item => !item.visable)
    },
     ...mapState({
      method: state => state.user.method,
      isMicroService: state => state.user.isMicroService,
      code: state => state.user.code,
      resData: state => state.user.resData
    })
  },
  mounted() {
    this.queryData();
    this.cycleQueryData()
  },
  beforeDestroy() {
      clearInterval(this.timerEnergyFiled);
  },
  methods: {
    // 查询页面数据
    queryData() {
      this.isLoading = true;
      this.queryFields().then(result => {
        result && this.queryFieldData()
      }).catch(() => {
        this.isLoading = false;
      })
    },
    cycleQueryData(){
      this.timerEnergyFiled = setInterval(() => {
        this.queryData()
      }, 60000)
    },
    // 查询参数列表
    queryFields() {
      let param = {
        devcode: this.deviceInfo.devcode,
        i18n: this.$lang.currentLang,
         uid:this.$store.state.user.uidExtra
      }
      let url = this.isMicroService ? "/ppe/api/auth/web/queryDeviceChartsFields" : "queryDeviceChartsFieldsEs";
      return  this.$request[this.method](url, param).then(res => {
        if (res[this.code] === 0) {
          this.fieldList = res[this.resData]
          return true
        } else {
          this.fieldList = []
          return false
        }
      }).catch(err => {
        this.fieldList = [];
        console.error('queryDeviceChartsFieldsEs 接口调用失败:', err);
        return false;
      })
    },
    // 查询参数数据
    queryFieldData() {
      let param = {
        devcode: this.deviceInfo.devcode,
        pn: this.deviceInfo.pn,
        devaddr: this.deviceInfo.devaddr,
        sn: this.deviceInfo.sn,
        i18n: this.$lang.currentLang,
        uid:this.$store.state.user.uidExtra
      }
      this.isLoading = true;
      let url = this.isMicroService ? "/ppe/api/auth/web/queryDevicePars" : "queryDeviceParsEs";
      this.$request[this.method](url, param).then(res => {
        if (res[this.code] === 0) {
          this.fieldDataList =this.isMicroService? res[this.resData]: res[this.resData].parameter
        }
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.error('queryDeviceParsEs 接口调用失败:', err);
      })
    },
    // 设置参数可见性
    setField (field, visible) {
      let param = {
        devcode: this.deviceInfo.devcode,
        optional: field.optional,
        visable: visible,
        uid:this.$store.state.user.uidExtra
      }
   let url = this.isMicroService ? "/ppe/api/auth/web/editDeviceChartsVisable" : "editDeviceChartsVisable";
        // info.Loading = true;
        this.$request[this.method](url,param).then(res => {
        if(res[this.code] === 0) {
          this.queryFieldData()
          field.visable = visible
        }
      })
    },
    // 重置参数可见性
    resetField() {
      let param = {
        devcode: this.deviceInfo.devcode,
        i18n: this.$lang.currentLang,
        uid:this.$store.state.user.uidExtra
      }
      let url = this.isMicroService ? "/ppe/api/auth/web/editDeviceChartsReset" : "editDeviceChartsReset";
        // info.Loading = true;
        this.$request[this.method](url, param).then(res => {
        if (res[this.code] === 0) {
          this.queryData()
        }
      })
    },
    // 关闭设置窗口
    closeSetting() {
      this.settingVisible = false
    }
  },
}
</script>
<style lang="less">
@import url('../assets/css/mixin.less');
.param-choose {
  .title {
    .sc(14px, #000);
  }
  .tag-container {
    display: grid;
    margin: 10px;
    grid-template-columns: auto auto auto;
    grid-gap: 10px 10px;
    .tag {
      background: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-width: 220px;
      @keyframes flip {
        0% {
          transform-origin: 50%;
          transform: rotateY(-90deg);
        }
        100% {
          transform: rotateY(0);
        }
      }
      animation: flip .3s linear;
      i {
        border-radius: 50%;
        text-align: center;
        cursor: pointer;
        font-size: 12px;
        height: 16px;
        width: 16px;
        margin-left: 5px;
        line-height: 16px;
        color: #fff;
        visibility: hidden;
        background: #ccc;
        &:hover {
          color: #fff;
          background: @themeColor;
        }
      }
      &.clickable {
        cursor: pointer;
      }
      &.clickable:hover {
        i {
          visibility: visible;
        }
      }
    }
    .tag-chosen {
      .tag;
      color: @themeColor;
      border-color: var(--bg-end-color);
    }
    .tag-optional {
      .tag;
      color: #666;
      border-color: @borderColor;
    }
  }
  .footer {
    border-top: 1px solid @borderColor;
    display: flex;
    justify-content: flex-end;
    padding-top: 12px;
    button {
      padding: 8px 20px;
      margin-left: 10px;
    }
  }
}
</style>
<style lang="less" scoped>
@import url('../assets/css/mixin.less');
.param {
  // padding: 10px 20px 25px;
  // margin-top: 20px;
  // padding: 16px;
  margin: 20px 10px 0 0;
  padding:0 10px 10px;
  display: flex;
  flex-direction: column;
  &-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding:10px 0 0 0;
    .text {
      .sc(14px, #333);
      font-weight: bold;
    }
    .param-set {
      i {
        .sc(20px, #ccc);
        cursor: pointer;
        &:hover {
          color: @themeColor;
        }
      }
    }
  }
  &-list {
    flex: 1;
    display: grid;
    align-content: center;
    grid-column-gap: 20px;
    &.protocol {
      grid-auto-flow: column;
      grid-auto-columns: 1fr;
    }
    &.device {
      grid-auto-flow: row;
      grid-auto-rows: 1fr;
    }
    .param-data {
      // padding:10px 45px;
      display: grid;
      flex-direction: column;
      margin-top: 10px;
      text-align: center;
      // background: #E7F1FC;
      &.protocol {
        border-radius: 5px;
        padding:10px 25px;
        background: #5495FD;
        .num {
        // align-self: flex-start;
        align-self: flex-end;
        .sc(28px, #fff);
      }
      .name {
        // align-self: center;
        align-self: flex-start;
        .sc(14px, #fff);
        margin-top: 10px;
      }
      }
      &.device {
        border-radius: 5px;
        padding:10px 45px;
        background: #E7F1FC;
        // background: #2AA983;
        .num {
        // align-self: flex-start;
        align-self: flex-end;
        .sc(28px, #000);
        // .sc(28px, #fff);
      }
      .name {
        // align-self: center;
        align-self: flex-start;
        .sc(14px, @themeColor);
        // .sc(14px, #ffffff);
        margin-top: 10px;
      }
      }
      
    }
  }
}
</style>
